import React from 'react';
import styled from 'styled-components';

import { useRouterLocation, useSelectorActiveChain } from '#/components/hooks';
import { dismissNotice } from '#/reduxState/notices/noticesReducer';
import { useDispatch, useSelector } from '#/reduxState/store';

import Banner from './Banner';
import BannerNoticeReferred from './BannerNoticeReferred';
import { useNotices } from './useNotice';

const Wrapper = styled.div`
  grid-area: banner-notice;
`;

/**
 * The BannerNotice is used for dynamic notifications which the user can generally dismiss.  It is located
 * directly below the NavBar on Desktop.
 */
export default function BannerNoticeWrap() {
  const dispatch = useDispatch();
  const { activeChain } = useSelectorActiveChain();
  const notices = useNotices('banners');
  const routerLocation = useRouterLocation();

  const referralCodeApplied = useSelector(
    state => state.currentUserData.userReferral.referralCodeApplied
  );

  const isPageWithoutBanner = routerLocation?.pathname === '/mobile-more/help';

  if (isPageWithoutBanner) {
    return null;
  }

  // User confirm state - directly after user click registration email link
  const userConfirmedEmailState =
    routerLocation?.search === '?userConfirmedEmail';

  // TODO: define wallet removal only when user session is expired/incorrect
  // if (currentUser.initialized && !currentUser.loggedIn && privateKeyEncrypted) {
  //   // Private key is stored, but user is not logged in
  //   return (
  //     <Wrapper>
  //       <Banner
  //         notice={{
  //           type: 'error',
  //           message: '',
  //           isDismissable: false,
  //         }}
  //       >
  //         You are not logged in but there is wallet stored in your browser. You
  //         can{' '}
  //         <RouterLink color="inherit" underline to="/login">
  //           log in
  //         </RouterLink>{' '}
  //         to keep using it, or{' '}
  //         <LinkClickable
  //           color="inherit"
  //           underline
  //           onClick={() => staticDispatch(removeWallet())}
  //         >
  //           remove the wallet
  //         </LinkClickable>
  //         .
  //       </Banner>
  //     </Wrapper>
  //   );
  // }

  if (referralCodeApplied) {
    return (
      <Wrapper>
        <BannerNoticeReferred />
      </Wrapper>
    );
  }

  if (userConfirmedEmailState) {
    return (
      <Wrapper>
        <Banner
          notice={{
            type: 'success',
            message: 'Your email address is confirmed!',
            isDismissable: false,
          }}
        />
      </Wrapper>
    );
  }
  const mainNotice = notices?.main;
  const secondaryNotice = notices?.secondary;

  if (mainNotice) {
    return (
      <Wrapper>
        <Banner
          notice={mainNotice}
          onClose={() =>
            dispatch(dismissNotice('banners', mainNotice.id, activeChain))
          }
        />
        {secondaryNotice && (
          <Banner
            notice={secondaryNotice}
            onClose={() =>
              dispatch(
                dismissNotice('banners', secondaryNotice.id, activeChain)
              )
            }
          />
        )}
      </Wrapper>
    );
  }
  return <Wrapper />;
}
